import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const Information = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="information-section">
        <div className="first-para">
          <h2>
            Project Description <span></span>
          </h2>
          <p>
           PRICE is the ecosystem providing pricing information for crypto and stocks of various kinds.
          </p>
        
          {/* <img
            src="\assets\alldetailpages\screx\bannner.png"
            className="img-fluid screximg"
          /> */}
        </div>
        {/* <div className="first-para">
          <h2>
            WHAT MAKE XEN UNIQUE? <span></span>
          </h2>
          <ul className="rain-list">
            <li>
              <span>All-in-One DeFi Hub:</span> XEN brings together every
              essential function of decentralized finance in one powerful,
              intuitive environment. Trade, stake, lend, farm, DAOs, perpetual
              contracts, escrow, and execute instant cross-chain bridging, all
              just a few clicks away, without the chaos of multiple apps.
            </li>
            <li>
              <span>Integration with Leading Protocols:</span> Real-time
              connections with top-tier DeFi protocols such as Uniswap, Aave,
              Curve, Balancer and Compound give XEN unmatched liquidity,
              competitive rates and instant access to proven market
              infrastructure from day one.
            </li>
            <li>
              <span>Full EVM interoperability:</span> Connect seamlessly with
              major EVM networks including Ethereum, BNB Chain, Polygon,
              Avalanche, Arbitrum, Optimism, Fantom and more. Move assets
              instantly to where they work most efficiently without external
              bridges, delays or unnecessary costs.
            </li>
            <li>
              <span> Smart Routing:</span> Advanced smart routing algorithms
              analyze the market in real time to select the fastest and most
              cost-efficient transaction path. You take action while Screx
              optimizes your costs and maximizes your returns.
            </li>
            <li>
              <span>Privacy on Your Terms:</span> Zero-Knowledge Proof
              technology gives you complete control over the visibility of your
              activity. Choose when to operate transparently and when to stay
              private without losing regulatory compliance.
            </li>
            <li>
              <span>Built-in Analytics and AI Assistant:</span> Powerful
              analytics tools and an AI assistant deliver real-time data,
              forecasts and personalized recommendations. This empowers you to
              act faster, invest smarter and stay one step ahead of the market.
            </li>
            <li>
              <span>Utility:</span> SCRX token unlocks reduced fees, access to
              exclusive premium features, governance participation and staking
              rewards. Its deflationary burn mechanism reduces supply as
              platform activity grows, supporting long-term value and rewarding
              active community members.
            </li>
          </ul>
        </div>
        <div className="first-para">
          <h2>
            Go-to-Market Strategy <span></span>
          </h2>
          <p>
            XEN's go-to-market strategy focuses on rapid market penetration and
            community-driven growth. This will be achieved through strategic
            partnerships with leading DeFi protocols, EVM chains, and wallet
            providers, ensuring accessibility where users already operate. The
            initial rollout will integrate with a minimum of 10 top-tier
            partners in the first year to secure immediate access to liquidity
            and multi-chain asset support, effectively delivering the
            convenience of a traditional banking app for the crypto economy.
            Adoption will be further boosted through targeted incentive
            campaigns, including zero-fee trading and staking bonuses, alongside
            a global ambassador network and influencer collaborations to expand
            brand visibility.
          </p>
          <p>
            Developer engagement will be prioritized with the release of XEN API
            suite, enabling dApps and institutional platforms to integrate smart
            routing, cross-chain bridging, and privacy tools. The strategy
            targets a diverse user base, from new entrants to advanced DeFi
            users and institutions. XEN aims to capture 2% of the market share
            by the end of 2026 (approximately $720 million) and 5% by the end of
            2027 (around $1.8 billion) within the $36 billion service
            addressable market. Revenue will be generated from various sources,
            including transaction fees, premium subscriptions, and license fees,
            positioning XEN to achieve multi-billion-dollar transaction volumes
            within its first two years.
          </p>
        </div> */}

        {/* <div className="first-para">
          <h2>
            {t("Inc-detailt34")} <span></span>
          </h2>
          <div className="team-gems">
            <div className="single-team">
              <div className="inner_single_team">
                <img
                  src="\assets\alldetailpages\screx\team\1.png"
                  alt="img"
                  className="img-fluid"
                />
                <div>
                  <h6 className="mb-0">TOM BABIAK </h6>
                  <h5>CEO of Screx</h5>
                </div>
              </div>

              <p>
                Technology leader with 12+ years’ experience, active in
                blockchain since 2016, including collaborations with Binance and
                Gate.io.
              </p>
            </div>
            <div className="single-team">
              <div className="inner_single_team">
                <img
                  src="\assets\alldetailpages\screx\team\2.png"
                  alt="img"
                  className="img-fluid"
                />
                <div>
                  <h6 className="mb-0">GREG ROGOWSKI </h6>
                  <h5>COO of Screx</h5>
                </div>
              </div>

              <p>
                Blockchain enthusiast since 2017, involved in trend-setting
                projects including the strategic growth of Mining City.
              </p>
            </div>
            <div className="single-team">
              <div className="inner_single_team">
                <img
                  src="\assets\alldetailpages\screx\team\3.png"
                  alt="img"
                  className="img-fluid"
                  style={{ objectPosition: "50%" }}
                />
                <div>
                  <h6 className="mb-0">MICHAL HOSSIEN </h6>
                  <h5>CBO of Screx</h5>
                </div>
              </div>

              <p>
                Business and technology expert with over a decade of experience
                in iGaming, Edutech, eSports, and blockchain, combining
                technical skills with strategic vision.
              </p>
            </div>
            <div className="single-team">
              <div className="inner_single_team">
                <img
                  src="\assets\alldetailpages\screx\team\4.png"
                  alt="img"
                  className="img-fluid"
                  style={{ objectPosition: "50%" }}
                />
                <div>
                  <h6 className="mb-0">KAMIL KIELBASA </h6>
                  <h5>CTO of Screx</h5>
                </div>
              </div>

              <p>
                Tech leader and solutions architect with 10+ years’ experience,
                building secure systems and leading teams for brands like
                Samsung and Danske Bank.
              </p>
            </div>
            <div className="single-team">
              <div className="inner_single_team">
                <img
                  src="\assets\alldetailpages\screx\team\5.png"
                  alt="img"
                  className="img-fluid"
                  style={{ objectPosition: "50%" }}
                />
                <div>
                  <h6 className="mb-0">MATT WESOLOWSKI </h6>
                  <h5>CCO of Screx</h5>
                </div>
              </div>

              <p>
                Creative director with 20 years in leading European agencies,
                delivering bold, high-impact visual design and branding.
              </p>
            </div>
          </div>
        </div> */}
        {/* <div className="first-para">
          <h2>
            Tokenomics <span></span>
          </h2>
          <p>
            The native utility token of the XEN ecosystem is XEN (ERC20,
            Ethereum), which has a total supply of 1,000,000,000 tokens. The
            token distribution is allocated across several categories, including
            the team, advisors, incentives, token sale, marketing, partnerships,
            liquidity, and a long-term treasury.
          </p>
          <p>The XEN token has several uses within the platform:</p>
          <ul>
            <li>
              Transaction Fees Covering network fees across the ecosystem.
            </li>
            <li>Staking earns rewards for helping to secure the platform.</li>
            <li>
              Governance Participating in decentralized decision-making by
              proposing and voting on platform developments.
            </li>
            <li>
              Premium Features Accessing advanced tools and in-depth analytics.
            </li>
            <li>Discounts Receiving reduced fees for platform services.</li>
          </ul>
          <p>
            XEN also incorporates a deflationary model, which includes burning a
            portion of transaction fees and conducting annual burn events to
            gradually reduce the token supply.
          </p>
        </div> */}
        {/* <div className="first-para">
          <div className="twice-tokenomics">
            {window.innerWidth < 600 ? (
              <div className="tokenomic-img">
                <img
                  style={{ mixBlendMode: "exclusion" }}
                  src="\assets\alldetailpages\screx\information\tokenomicsdarkmbl.png"
                  alt="img"
                  className="img-fluid "
                />
                <img
                  // style={{ mixBlendMode: "multiply" }}
                  src="\assets\alldetailpages\screx\information\tokenomicslightmbl.png"
                  alt="img"
                  className="img-fluid "
                />
              </div>
            ) : (
              <div className="tokenomic-img">
                <img
                  style={{ mixBlendMode: "exclusion" }}
                  src="\assets\alldetailpages\screx\information\tokenomicsdark.png"
                  alt="img"
                  className="img-fluid hide-in-light-theme"
                />
                <img
                  // style={{ mixBlendMode: "multiply" }}
                  src="\assets\alldetailpages\screx\information\tokenomicslight.png"
                  alt="img"
                  className="img-fluid d-none show-in-light-theme "
                />
              </div>
            )}
          </div>
        </div> */}
        {/* <div className="first-para mt-3">
          <div className="twice-tokenomics">
            {window.innerWidth < 600 ? (
              <div className="tokenomic-img">
                <img
                  style={{ mixBlendMode: "exclusion" }}
                  src="\assets\alldetailpages\screx\information\graphdarkmbl.png"
                  alt="img"
                  className="img-fluid "
                />
                <img
                  // style={{ mixBlendMode: "multiply" }}
                  src="\assets\alldetailpages\screx\information\graphlightmbl.png"
                  alt="img"
                  className="img-fluid  "
                />
              </div>
            ) : (
              <div className="tokenomic-img">
                <img
                  style={{ mixBlendMode: "exclusion" }}
                  src="\assets\alldetailpages\screx\information\graphdark.png"
                  alt="img"
                  className="img-fluid"
                />
                <img
                  // style={{ mixBlendMode: "multiply" }}
                  src="\assets\alldetailpages\screx\information\graphlight.png"
                  alt="img"
                  className="img-fluid d-none show-in-light-theme "
                />
              </div>
            )}
          </div>
        </div> */}
      </section>
    </>
  );
};

export default Information;
